import { ChatWidget } from "./widget";

function init(): void {
  const script =
    (document.currentScript as HTMLScriptElement | null) ??
    (document.querySelector('script[src*="widget"]') as HTMLScriptElement | null) ??
    (document.querySelector('script[data-site]') as HTMLScriptElement | null);
  const site = script?.dataset.site ?? "maximilius";
  new ChatWidget(site);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
